<template>
    <div class="tm-item-card-properties">
        <ul class="uk-list">
            <product-property-row v-for="propertyValue in properties"
                                  :key="propertyValue.ShopProperty.id"
                                  :property="propertyValue.ShopProperty"
                                  :value="propertyValue.ShopPropertyValue"
            >
            </product-property-row>
        </ul>
    </div>
</template>

<script>
    import ProductPropertyRow from './ProductPropertyRow'

    export default {
        name: "ShopItemProperties",
        components: {
            ProductPropertyRow
        },
        props: {
            properties: {
                type: Array,
                default() {
                    return []
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ProductProperties.vue?1ffdb4ba